// import lib
import { lazy } from "react";

const routes = [
  {
    exact: true,
    path: "/change_password",
    element: lazy(() => import("../pages/ManageSeller/chnagePassword")),
  },
];

export default routes;
